import { combineReducers } from 'redux';

import accountSettings from './accountSettings';
import categories from './categories';
import devices from './devices';
import drycleaning from './drycleaning';
import locations from './locations';
import modifiers from './modifiers.js';
import preferences from './preferences.js';
import products from './products';
import promotions from './promotions';
import services from './services';
import taskManager from './taskManager';
import teams from './teams';

export default combineReducers({
	locations,
	devices,
	accountSettings,
	taskManager,
	teams,
	services,
	products,
	promotions,
	preferences,
	drycleaning,
	categories,

	modifiers,
});
